import React, { useEffect, useState } from "react";
import "./episodeList.css";
import { getPlaylist, getYoutubePlaylist } from "../api/core";
import Share from "../share/share";
import Global from "../../global.js";
import { Link } from "react-router-dom";
import {
  favourited,
  favourites,
  formatUTCDate,
  getPercentage,
} from "../javascript/function";
import { UserStore } from "../store/store";
import LazyDiv from "../lazy/lazydiv";
import Icon from "../icon/icon";

const EpisodeList = (props) => {
  const initstate = { playlist: [] };
  /* eslint-disable no-unused-vars */
  const [seasonItem, setSeasonItem] = useState([]);
  /* eslint-disable no-unused-vars */
  const [loading, isLoading] = useState(true);
  const [error, SetError] = useState(false);
  const [seasonPlay, setSeasonPlay] = useState(initstate);
  const [seasonPlayid, setSeasonPlayid] = useState("");
  const currentUser = UserStore.useState((s) => s.user);
  const handleChange = async (event) => {
    setSeasonPlayid(event.target.value);

    if (Global.VCMS === "YouTube") {
      const result = await getYoutubePlaylist(event.target.value, 50).then(
        (result) => {
          setSeasonPlay(result.data);
        },
        (error) => {}
      );
    } else {
      const result = await getPlaylist(event.target.value, 50).then(
        (result) => {
          setSeasonPlay(result.data);
        },
        (error) => {}
      );
    }
  };

  useEffect(() => {
    const PLSplaylistDetail = async (id, limit) => {
      /* eslint-disable no-unused-vars */
      if (Global.VCMS === "YouTube") {
        const result = await getYoutubePlaylist(id, limit).then(
          (result) => {
            setSeasonPlay(result.data);
          },
          (error) => {}
        );
      } else {
        const result = await getPlaylist(id, limit).then(
          (result) => {
            setSeasonPlay(result.data);
          },
          (error) => {}
        );
      }

      /* eslint-disable no-unused-vars */
    };

    const FullPageDetail = async (app, id) => {
      setSeasonItem(props.data);
      setSeasonPlayid(props.data[0].itemid);
      PLSplaylistDetail(props.data[0].itemid, 50);
    };
    FullPageDetail(
      props.match.params.AppId,
      props.match.params.videoId ? props.match.params.videoId : props.detail._id
    );
    isLoading(false);
  }, [
    props.detail._id,
    props.match.params.AppId,
    props.match.params.videoId,
    props.data,
  ]);
  if (!error && !loading) {
    return (
      <div id="movie-card-list">
        <div className="selector">
          <select className="selects form-control" onChange={handleChange}>
            {props.data !== null
              ? props.data.map((item, index) => (
                  <option key={index} value={item.itemid}>
                    {item.itemRef}
                  </option>
                ))
              : ""}
          </select>
          {/*   <select className="selects form-control right">
                    <option value="1">Sort By A-Z</option>
                    <option value="2">Sort By Episode</option>
                    <option value="3">Sort By Name</option>
                  </select> */}
        </div>

        {seasonPlayid !== null && seasonPlayid !== undefined
          ? Global.VCMS === "YouTube"
            ? seasonPlay.items !== undefined
              ? seasonPlay.items.map((item, index) => (
                  <div key={index} className="movie-card">
                    <div className="movie-card__overlay" />
                    <LazyDiv
                      className="movie-card-image"
                      data-movie={item.snippet.title}
                      style={{
                        backgroundImage:
                          `url(https://img.youtube.com/vi/` +
                          item.contentDetails.videoId +
                          `/mqdefault.jpg)`,
                      }}
                    >
                      {/* {item.ContentType==="Premium"?<Icon flag={"transparent"}></Icon>:""} */}
                    </LazyDiv>
                    <div className="movie-card__content">
                      <div className="movie-card__header">
                        <h1 className="movie-card__title">
                          {item.snippet.title}
                        </h1>
                        <h4 className="movie-card__info">
                          {formatUTCDate(item.snippet.publishedAt)}{" "}
                        </h4>
                      </div>
                      <p className="movie-card__desc">
                        {item.snippet.description}
                      </p>
                      <div className="movie-card__share">
                        {/* movie-card__icon */}
                        <Link
                          to={
                            "/" +
                            props.match.params.AppId +
                            "/episode/" +
                            seasonPlayid +
                            "/watch/" +
                            item.contentDetails.videoId +
                            "/" +
                            (index + 1)
                          }
                          className="btn btn-hover"
                        >
                          <i className="fa fa-play mr-2" aria-hidden="true" />
                          Watch Now
                        </Link>
                        <div className="float-right">
                          {Global.FAVOURITES ? (
                            <span
                              className="host_icon"
                              onClick={(event) => {
                                favourites(event, item, "video");
                              }}
                            >
                              <i
                                className={
                                  favourited(
                                    item.contentDetails.videoId,
                                    currentUser.FAVOURITES
                                  )
                                    ? "ri-check-fill text-white"
                                    : "ri-add-line text-white"
                                }
                              ></i>
                            </span>
                          ) : (
                            ""
                          )}

                          {Global.SOS ? (
                            <span className="movie-card__icon shared">
                              <i className="ri-share-line text-white"></i>
                              <Share
                                type={"video"}
                                details={item}
                                {...props}
                              ></Share>
                            </span>
                          ) : (
                            ""
                          )}
                          {Global.OFFLINE ? (
                            <span className="movie-card__icon">
                              <i className="ri-download-line text-white"></i>
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                    <div className={"cwwrapper transparent"}>
                      <div
                        className="cwprogress whited"
                        style={{
                          width: Global.RPB
                            ? getPercentage(
                                item.contentDetails.videoId,
                                currentUser.WATCHHISTORY
                              ) + "%"
                            : 0 + "%",
                        }}
                      ></div>
                    </div>
                  </div>
                ))
              : ""
            : seasonPlay.playlist.map((item, index) => (
                <div key={index} className="movie-card">
                  <div className="movie-card__overlay" />
                  <LazyDiv
                    className="movie-card-image"
                    data-movie={item.title}
                    style={{
                      backgroundImage: `url(` + item.images[3].src + `)`,
                    }}
                  >
                    {item.ContentType === "Premium" ? (
                      <Icon flag={"transparent"}></Icon>
                    ) : (
                      ""
                    )}
                  </LazyDiv>
                  <div className="movie-card__content">
                    <div className="movie-card__header">
                      <h1 className="movie-card__title">{item.title}</h1>
                      <h4 className="movie-card__info">
                        {parseInt(item.duration / 60) + "Mins"}{" "}
                      </h4>
                    </div>
                    <p className="movie-card__desc">{item.description}</p>
                    <div className="movie-card__share">
                      {/* movie-card__icon */}
                      <Link
                        to={
                          "/" +
                          props.match.params.AppId +
                          "/episode/" +
                          seasonPlayid +
                          "/watch/" +
                          item.mediaid +
                          "/" +
                          (index + 1)
                        }
                        className="btn btn-hover"
                      >
                        <i className="fa fa-play mr-2" aria-hidden="true" />
                        Watch Now
                      </Link>
                      <div className="float-right">
                        {Global.FAVOURITES ? (
                          <span
                            className="host_icon"
                            onClick={(event) => {
                              favourites(event, item, "video");
                            }}
                          >
                            <i
                              className={
                                favourited(item.mediaid, currentUser.FAVOURITES)
                                  ? "ri-check-fill text-white"
                                  : "ri-add-line text-white"
                              }
                            ></i>
                          </span>
                        ) : (
                          ""
                        )}

                        {Global.SOS ? (
                          <span className="movie-card__icon shared">
                            <i className="ri-share-line text-white"></i>
                            <Share
                              type={"video"}
                              details={item}
                              {...props}
                            ></Share>
                          </span>
                        ) : (
                          ""
                        )}
                        {Global.OFFLINE ? (
                          <span className="movie-card__icon">
                            <i className="ri-download-line text-white"></i>
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  <div className={"cwwrapper transparent"}>
                    <div
                      className="cwprogress whited"
                      style={{
                        width: Global.RPB
                          ? getPercentage(
                              item.mediaid,
                              currentUser.WATCHHISTORY
                            ) + "%"
                          : 0 + "%",
                      }}
                    ></div>
                  </div>
                </div>
              ))
          : ""}
      </div>
    );
  } else {
    return <div></div>;
  }
};
export default EpisodeList;
